var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80.2 80",
    style: {
      enableBackground: "new 0 0 80.2 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "t1b995d4",
    d: "M29.6,40.9C33,28.3,29.1,15.1,20,8.1C7.6,16,0.4,30.8,3,46.2c0.9,5.1,2.7,9.8,5.3,13.9  C18,57.4,26.6,52.3,29.6,40.9 M46.4,77.2c20.6-3.5,34.4-22.9,31-43.5C74.5,16.6,60.6,4.2,44.1,2.5c-3.3-0.3-6.7-0.3-10.2,0.3  c-4.1,0.7-7.9,2-11.4,3.9C40.6,12.8,50.4,22.1,51,31.7c0.3,5.9-2.4,10.2-6,13.7l25.6-1.8c0.7,0,1,0.8,0.1,1L9.6,62.1  c6.2,8.6,15.9,14.3,26.6,15.4C39.5,77.9,43,77.8,46.4,77.2 M44.4,0.2C64.5,2.3,80.2,19.3,80.2,40c0,22.1-17.9,40-40,40  s-40-17.9-40-40s17.9-40,40-40C41.6,0,43,0.1,44.4,0.2",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d9e1c572",
    d: "M3,46.2c0.9,5.1,2.7,9.8,5.3,13.9c9.7-2.7,18.3-7.8,21.3-19.3C33,28.3,29.1,15.1,20,8.1C7.6,16,0.4,30.8,3,46.2   M77.4,33.7c3.5,20.5-10.4,40-31,43.5c-3.5,0.6-6.9,0.7-10.2,0.3c-10.7-1.1-20.4-6.8-26.6-15.4l61.1-17.5c0.9-0.3,0.7-1.1-0.1-1  L45,45.4c3.6-3.5,6.4-7.8,6-13.7c-0.7-9.6-10.4-18.9-28.5-25.1c3.5-1.8,7.3-3.2,11.4-3.9c3.5-0.6,6.9-0.7,10.2-0.3  C60.6,4.2,74.5,16.6,77.4,33.7",
    fill: "#C81618"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/TK.8a1888f266680f8b1a3fda36c5466a6a.svg";
export { ForwardRef as ReactComponent };